var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { attrs: { id: "footer_main" } }, [
    _c("div", [
      _c("div", { staticClass: "footer_area" }, [
        _c("img", {
          staticClass: "footer_img",
          attrs: { src: this.getImage("top/mori.png") }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "footer_block" }, [
          _c("div", { staticClass: "footer_line" }),
          _vm._v(" "),
          _c("div", { staticClass: "footer_item" }, [
            _c("div", [
              _c("img", {
                staticClass: "icon",
                attrs: { src: this.getImage("common/icon_factory.svg") }
              })
            ]),
            _vm._v(" "),
            _vm._m(0)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer_line" }),
          _vm._v(" "),
          _c("div", { staticClass: "footer_item" }, [
            _c("div", [
              _c("img", {
                staticClass: "icon",
                attrs: { src: this.getImage("common/icon_warranty.svg") }
              })
            ]),
            _vm._v(" "),
            _vm._m(1)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer_line" }),
          _vm._v(" "),
          _c("div", { staticClass: "footer_item" }, [
            _c("div", [
              _c("img", {
                staticClass: "icon",
                attrs: { src: this.getImage("common/icon_cash.svg") }
              })
            ]),
            _vm._v(" "),
            _vm._m(2)
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "footer_line" })
        ])
      ]),
      _vm._v(" "),
      _vm._m(3)
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "footer_category_area" }, [
      _c("div", { staticClass: "space" }),
      _vm._v(" "),
      _c("div", { staticClass: "footer_logo" }, [
        _c("img", { attrs: { src: this.getImage("common/logo.png") } })
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "footer_category" }, [
        _c("div", { staticClass: "company" }, [
          _c("ul", [
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcCategory")
                    }
                  }
                },
                [_vm._v("商品を選ぶ")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcPaymentGuide")
                    }
                  }
                },
                [_vm._v("ご利用ガイド")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcRouteConfirm")
                    }
                  }
                },
                [_vm._v("搬入経路のご確認")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcGuideOrder")
                    }
                  }
                },
                [_vm._v("送料・納期・配送")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcGuidePayment")
                    }
                  }
                },
                [_vm._v("お支払い方法")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcCorpInformation")
                    }
                  }
                },
                [_vm._v("会社概要")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("SupportInput")
                    }
                  }
                },
                [_vm._v("お問い合わせ")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("UseRule")
                    }
                  }
                },
                [_vm._v("利用規約")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcTokutei")
                    }
                  }
                },
                [_vm._v("特定商取引法に基づく表示")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.route("DcPrivacyPolicy")
                    }
                  }
                },
                [_vm._v("プライバシーポリシー")]
              )
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "category" }, [
          _c("ul", [
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 1 })
                    }
                  }
                },
                [_vm._v("吊戸棚")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 2 })
                    }
                  }
                },
                [_vm._v("食器棚")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 3 })
                    }
                  }
                },
                [_vm._v("玄関収納")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 5 })
                    }
                  }
                },
                [_vm._v("棚板")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 6 })
                    }
                  }
                },
                [_vm._v("カウンター下収納")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 7 })
                    }
                  }
                },
                [_vm._v("サイドボード")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 8 })
                    }
                  }
                },
                [_vm._v("テレビボード")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 9 })
                    }
                  }
                },
                [_vm._v("本棚")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 14 })
                    }
                  }
                },
                [_vm._v("クローゼット収納")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 15 })
                    }
                  }
                },
                [_vm._v("隙間収納")]
              )
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "item_category" }, [
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      _vm.routeCategory("DcCategory", { cid: 18 })
                    }
                  }
                },
                [_vm._v("シェルフ")]
              )
            ])
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { attrs: { id: "copyright" } }, [
      _vm._v("Copyright ©" + _vm._s(_vm.year) + " domans all rights reserved. ")
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "footer_text" }, [_vm._v("国内製造・工場直送")]),
      _vm._v(" "),
      _c("div", { staticClass: "footer_subtext" }, [
        _vm._v(
          "ご注文確定から岐阜県郡上八幡にある工場にて製造を開始します。工場から直送させていただきます。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "footer_text" }, [_vm._v("安心の1年保証")]),
      _vm._v(" "),
      _c("div", { staticClass: "footer_subtext" }, [
        _vm._v(
          "配達中の商品破損や、取扱説明書に従った使用状態で保証期間内に故障した場合は、無償修理の対応をさせていただきます。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("div", { staticClass: "footer_text" }, [_vm._v("追加料金一切なし")]),
      _vm._v(" "),
      _c("div", { staticClass: "footer_subtext" }, [
        _vm._v(
          "商品をカスタマイズすると、すぐにお見積もり価格が表示されます。その価格から追加で費用がかかることはございません。"
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("a", { attrs: { href: "#", id: "page_top" } })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-886d90ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-886d90ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/main/js/hakotan/components/common/DcFooter.vue
// module id = null
// module chunks = 